import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Chip } from '@mui/material'
import { getUpdateTypeKey, getUpdateTypeLabel } from './constants'
import { useChipStyles } from './styles'

/** "New feature" / "Improvement" / "Fix" / "Announcement", coloured by type. */
export const UpdateTypeChip = ({ type, dataTest = 'whats-new-type-chip' }) => {
  const classes = useChipStyles()
  return (
    <Chip
      size='small'
      label={getUpdateTypeLabel(type)}
      className={clsx(classes.chip, classes[getUpdateTypeKey(type)])}
      data-test={dataTest}
    />
  )
}

UpdateTypeChip.propTypes = {
  type: PropTypes.string,
  dataTest: PropTypes.string
}

/**
 * The plan an un-gated upsell note belongs to ("Available on Enterprise").
 * Naming the plan is what keeps such a note from reading as a tease.
 */
export const PlanChip = ({ label, dataTest = 'whats-new-plan-chip' }) => {
  const classes = useChipStyles()
  if (!label) return null
  return <Chip size='small' label={label} className={clsx(classes.chip, classes.plan)} data-test={dataTest} />
}

PlanChip.propTypes = {
  label: PropTypes.string,
  dataTest: PropTypes.string
}
